import axios from 'axios';

// Basis-URL dynamisch: ENV first, fallback production/lokal
const getApiBaseUrl = () => {
  // Wenn ENV Variable gesetzt ist, verwende sie
  if (process.env.REACT_APP_API_BASE_URL) {
    let url = process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
    // WICHTIG: Wenn kein Protokoll, füge https:// hinzu
    if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      url = `https://${url}`;
    }
    return url;
  }
  // Bei Vercel (production): Gleiche Domain wie Frontend (relative URLs)
  if (process.env.NODE_ENV === 'production') {
    return ''; // Relative URLs - gleiches Host
  }
  // Development: localhost Backend
  return 'http://localhost:5000';
};

export const API_BASE_URL = getApiBaseUrl();
const ASSET_BASE = (process.env.REACT_APP_ASSET_BASE_URL || '').replace(/\/$/, '');
const API_URL = API_BASE_URL ? `${API_BASE_URL}/api` : '/api';

// Debug: Log API configuration
console.log('[API Config]', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_BASE_URL,
  API_URL
});
export const buildAssetUrl = (path) => {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  if (ASSET_BASE) return `${ASSET_BASE}${path}`;
  return path; // relative zum Frontend-Host (Vercel oder localhost:3000)
};

// Stelle sicher, dass alle Anfragen UTF-8 verwenden
axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.headers.put['Content-Type'] = 'application/json; charset=utf-8';

// Interceptor für Responses um UTF-8 sicherzustellen
axios.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'string') {
      try {
        response.data = JSON.parse(response.data);
      } catch (e) {
        // Bereits JSON oder kein JSON
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
);

// ==================== ROHLINGE ====================

export const getRohlinge = async () => {
  const url = `${API_URL}/rohlinge`;
  console.log('[API] Fetching rohlinge from:', url);
  const response = await axios.get(url);
  console.log('[API] Rohlinge response:', response.data);
  return response.data;
};

export const getRohlingeAdmin = async () => {
  const url = `${API_URL}/rohlinge`;
  console.log('[API] Fetching rohlinge (admin) from:', url);
  const response = await axios.get(url, { params: { includeInactive: 'true' } });
  console.log('[API] Rohlinge (admin) response:', response.data);
  return response.data;
};

export const getRohling = async (id) => {
  const response = await axios.get(`${API_URL}/rohlinge/${id}`);
  return response.data;
};

export const createRohling = async (formData) => {
  const response = await axios.post(`${API_URL}/rohlinge`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateRohling = async (id, formData) => {
  const response = await axios.put(`${API_URL}/rohlinge/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteRohling = async (id) => {
  const response = await axios.delete(`${API_URL}/rohlinge/${id}`);
  return response.data;
};

// ==================== FARBVARIANTEN ====================

export const addFarbvariante = async (rohlingId, formData) => {
  const response = await axios.post(`${API_URL}/rohlinge/${rohlingId}/farbvarianten`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateFarbvariante = async (rohlingId, farbvarianteId, formData) => {
  const response = await axios.put(`${API_URL}/rohlinge/${rohlingId}/farbvarianten/${farbvarianteId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteFarbvariante = async (rohlingId, farbvarianteId) => {
  const response = await axios.delete(`${API_URL}/rohlinge/${rohlingId}/farbvarianten/${farbvarianteId}`);
  return response.data;
};

// ==================== GRAVURFARBEN ====================

export const getGravurfarben = async () => {
  const response = await axios.get(`${API_URL}/gravurfarben`);
  return response.data;
};

export const createGravurfarbe = async (data) => {
  const response = await axios.post(`${API_URL}/gravurfarben`, data);
  return response.data;
};

export const updateGravurfarbe = async (id, data) => {
  const response = await axios.put(`${API_URL}/gravurfarben/${id}`, data);
  return response.data;
};

export const deleteGravurfarbe = async (id) => {
  const response = await axios.delete(`${API_URL}/gravurfarben/${id}`);
  return response.data;
};

// ==================== ROHLING-FARBEN ====================

export const getRohlingfarben = async () => {
  const response = await axios.get(`${API_URL}/rohlingfarben`);
  return response.data;
};

export const createRohlingfarbe = async (data) => {
  const response = await axios.post(`${API_URL}/rohlingfarben`, data);
  return response.data;
};

export const updateRohlingfarbe = async (id, data) => {
  const response = await axios.put(`${API_URL}/rohlingfarben/${id}`, data);
  return response.data;
};

export const deleteRohlingfarbe = async (id) => {
  const response = await axios.delete(`${API_URL}/rohlingfarben/${id}`);
  return response.data;
};

// ==================== SCHRIFTARTEN ====================

export const getSchriftarten = async () => {
  const response = await axios.get(`${API_URL}/schriftarten`);
  return response.data;
};

export const createSchriftart = async (data) => {
  const response = await axios.post(`${API_URL}/schriftarten`, data);
  return response.data;
};

export const updateSchriftart = async (id, data) => {
  const response = await axios.put(`${API_URL}/schriftarten/${id}`, data);
  return response.data;
};

export const deleteSchriftart = async (id) => {
  const response = await axios.delete(`${API_URL}/schriftarten/${id}`);
  return response.data;
};

export const uploadSchriftartFont = async (formData) => {
  const response = await axios.post(`${API_URL}/schriftarten/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// ==================== BILDER ====================

export const getBilder = async () => {
  const response = await axios.get(`${API_URL}/bilder`);
  return response.data;
};

export const createBild = async (formData) => {
  const response = await axios.post(`${API_URL}/bilder`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteBild = async (id) => {
  const response = await axios.delete(`${API_URL}/bilder/${id}`);
  return response.data;
};

// ==================== E-MAIL ====================

export const getEmailConfig = async () => {
  const response = await axios.get(`${API_URL}/config/email`);
  return response.data;
};

export const saveEmailConfig = async (config) => {
  const response = await axios.post(`${API_URL}/config/email`, config);
  return response.data;
};

export const sendMockup = async (data) => {
  const response = await axios.post(`${API_URL}/send-mockup`, data);
  return response.data;
};

// ==================== HOLZ-ANHÄNGER ====================

export const getHolzAnhaenger = async () => {
  const response = await axios.get(`${API_URL}/holz-anhaenger`);
  return response.data;
};

export const createHolzAnhaenger = async (formData) => {
  const response = await axios.post(`${API_URL}/holz-anhaenger`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateHolzAnhaenger = async (id, formData) => {
  const response = await axios.put(`${API_URL}/holz-anhaenger/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteHolzAnhaenger = async (id) => {
  const response = await axios.delete(`${API_URL}/holz-anhaenger/${id}`);
  return response.data;
};
